import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EOpenNewReviewForm } from './openFormActionsTypes';
import { resetStep } from './stepActionsTypes';
import { clearNewReviewFormAction } from './newReviewsAction';
import { selectIsLastContentStep } from '../../selectors/newReview/selectIsLastContentStep';

export const setNewReviewFormOpenAction = actionGenerator<EOpenNewReviewForm.Open>(EOpenNewReviewForm.Open);
export const setNewReviewFormCloseAction = actionGenerator<EOpenNewReviewForm.Close>(EOpenNewReviewForm.Close);

export function setNewReviewFormOpen(): TThunkAction<Promise<void>> {
  return async dispatch => {
    dispatch(setNewReviewFormOpenAction());
  };
}

export function setNewReviewFormClose(): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const state = getState();
    const isLastContentStep = selectIsLastContentStep(state);

    dispatch(resetStep());
    dispatch(setNewReviewFormCloseAction());

    if (isLastContentStep) {
      dispatch(clearNewReviewFormAction());
    }
  };
}
